import "./index.css"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useGlobal } from "../../../../context/global"
import PageLoader from "../../../../components/info/pageloader"
import moment from "moment"
import DP from "../../../../components/custom/dp"
import Icon from "../../../../components/custom/icon"

const AdminHome = () => {
    const { auth, api } = useGlobal()
    const { user } = auth
    const navigate = useNavigate()

    const [homeData, setHomeData] = useState()

    useEffect(() => {
        api.call('/get-home-data', user).then(({ data }) => {
            setHomeData(data)
        }).catch(err => {
            console.error("Failed to load admin home data", err)
        })
    }, [])

    if (!homeData) {
        return <PageLoader text="Loading administrator dashboard..." />
    }

    const { sevas, stats } = homeData

    return (
        <div className="admin-home flex-col">
            <div className="welcome-banner">
                <h2>Hare Krishna, {user.initiationName || user.name}</h2>
                <p>Administrator Dashboard</p>
            </div>

            <div className="admin-stats-grid">
                <div className="stat-card ops-pending" onClick={() => navigate("/applicants", { state: { tab: 0 } })}>
                    <div className="stat-icon">
                        <Icon name="search" color="var(--surface)" size={8} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.opsPending}</h3>
                        <p>Data Check Pending</p>
                    </div>
                </div>

                <div className="stat-card preacher-pending" onClick={() => navigate("/applicants", { state: { tab: 1 } })}>
                    <div className="stat-icon">
                        <Icon name="rate_review" color="var(--selected)" size={8} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.preacherPending}</h3>
                        <p>Screening Pending</p>
                    </div>
                </div>

                <div className="stat-card admin-pending" onClick={() => navigate("/applicants", { state: { tab: 2 } })}>
                    <div className="stat-icon">
                        <Icon name="gavel" color="var(--bar)" size={8} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.adminPending}</h3>
                        <p>Approval Pending</p>
                    </div>
                </div>

                <div className="stat-card total-vols" onClick={() => navigate("/volunteers")}>
                    <div className="stat-icon">
                        <Icon name="group" color="var(--green)" size={8} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.totalVolunteers}</h3>
                        <p>Total Approved</p>
                    </div>
                </div>
            </div>

            <div className="upcoming-festivals">
                <h3>Upcoming Festivals & Sevas</h3>
                {sevas && sevas.length > 0 ? (
                    <div className="festival-list flex-col">
                        {sevas.map(seva => (
                            <div className="festival-card flex-row" key={seva.id}>
                                <div className="festival-dp">
                                    <DP url={`https://cdn.iskconmysore.org/content?path=sevabase/seva/${seva.id}.jpg`} size={[14, 5]} enlarge />
                                </div>
                                <div className="festival-info flex-col">
                                    <span className="festival-name bold">{seva.name}</span>
                                    <span className="festival-date">
                                        {seva.date === seva.maxDate 
                                            ? moment(seva.date).format("dddd, Do MMM YYYY") 
                                            : `${moment(seva.date).format("ddd, Do")} - ${moment(seva.maxDate).format("ddd, Do MMM")} ${moment(seva.date).format("YYYY")}`}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-festivals">No upcoming festivals found.</div>
                )}
            </div>
        </div>
    )
}

export default AdminHome
